var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',{staticStyle:{"text-align":"center"},attrs:{"background":"","current-page":_vm.page,"page-sizes":[10, 20, 50, 100, 1000, 5000, 99999],"page-size":_vm.limit,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"current-change":_vm.handleCurrentChange,"size-change":_vm.sizeChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }